import styled from 'styled-components';

import { maxWidth } from '@utils/helpers';

export const HeaderLogoWrapper = styled.div`
    display: flex;
    gap: 26px;

    ${maxWidth('md')} {
        gap: 8px;
    }
`;

export const SpeekiLogoWrapper = styled.div`
    padding-top: 14px;

    ${maxWidth('md')} {
        padding-top: 23px;
    }
`;

export const BrandLogoWrapper = styled.div`
    align-self: center;
    cursor: pointer;
`;

export const BrandLogo = styled.img`
    display: block;
    max-height: 56px;
    max-width: 150px;

    ${maxWidth('md')} {
        max-height: 45px;
        max-width: 114px;
    }

    ${maxWidth('xxs')} {
        max-width: 114px;
        max-height: 33px;
    }
`;
